import React from "react";
import CustomModal from "../../components/CustomModal";
import TagInput from "../../components/common/CustomTagSelector"; 
import ImageUploader from "../../components/common/CustomImageUploader"; 
import CustomDatePicker from "../../components/common/CustomDatePicker";

const ViewProductModal = ({ open, onClose, product }) => {
  if (!product) return null;

  const fields = [
    { label: "Mã hàng", name: "id", type: "text", value: product.sku, fullWidth: false, tab: "Thông tin chung" },
    { label: "Tên hàng", name: "name", type: "text", value: product.name, fullWidth: false, tab: "Thông tin chung" },
    { label: "SKU", name: "sku", type: "text", value: product.sku, fullWidth: false, tab: "Thông tin chung" },
    { label: "Danh mục", name: "category", type: "text", value: product.category, fullWidth: false, tab: "Thông tin chung" },
    { label: "Giá bán", name: "price", type: "text", value: product.price, fullWidth: false, tab: "Thông tin chung" },
    { label: "Số lượng", name: "quantity", type: "text", value: product.quantity, fullWidth: false, tab: "Thông tin chung" },
    { label: "Tổng số bán", name: "sales", type: "text", value: product.sales, fullWidth: false, tab: "Thống kê" },
    { label: "Trạng thái kho", name: "stockStatus", type: "text", value: product.stockStatus, fullWidth: false, tab: "Thống kê" },
    { label: "Giảm giá", name: "discount", type: "text", value: product.discount, fullWidth: false, tab: "Khuyến mãi" },
    { label: "Đánh giá", name: "rating", type: "text", value: `${product.rating} ⭐`, fullWidth: false, tab: "Đánh giá & Xếp hạng" },
    { label: "Nhà cung cấp", name: "supplier", type: "text", value: product.supplier, fullWidth: false, tab: "Thông tin chung" },
    { label: "Cập nhật lần cuối", name: "lastUpdated", type: "text", value: product.lastUpdated, fullWidth: false, tab: "Lịch sử cập nhật" },
    { label: "Hình ảnh sản phẩm", name: "images", type: "image", value: [product.img], fullWidth: true, tab: "Hình ảnh" },
  ];

  // Tạo danh sách tab từ danh sách `fields`
  const groupedFields = {};
  fields.forEach(field => {
    const tab = field.tab || "Thông tin chung";
    if (!groupedFields[tab]) groupedFields[tab] = [];
    groupedFields[tab].push(field);
  });

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Chi tiết sản phẩm"
      fields={fields}
      tabLabels={Object.keys(groupedFields)} // Tạo tab tự động từ keys của groupedFields
      readOnly={true}
      modalWidth="90%"
      customComponents={{
        tags: TagInput,       
        images: ImageUploader, 
        expiryDate: CustomDatePicker, 
      }}
    />
  );
};

export default ViewProductModal;
